export enum ExpeditionType {
  '' = '-',
  'Fixed' = 'Fixed',
  'HybridWithFixedPoints' = 'HybridWithFixedPoints',
  'DynamicWithFixedPoints' = 'DynamicWithFixedPoints',
  'HybridDoor2Door' = 'HybridDoor2Door',
  'DynamicDoor2Door' = 'DynamicDoor2Door',
}

export function isDoor2DoorExpeditionType(expeditionType?: ExpeditionType): boolean {
  return expeditionType === ExpeditionType.HybridDoor2Door || expeditionType === ExpeditionType.DynamicDoor2Door;
}
